// Move announcement bar outside header-wrapper-container for proper sticky behavior
(function() {
  function hoistAnnouncementBar() {
    const headerWrapper = document.querySelector('.header-wrapper-container');
    if (!headerWrapper) return;

    // Find announcement bar section (Shopify wraps sections with shopify-section class).
    // Once hoisted the bar is no longer a descendant, so re-running this is a no-op.
    const announcementBar = headerWrapper.querySelector('.header-wrapper-container-announcement-bar');
    if (!announcementBar) return;

    const announcementSection = announcementBar.closest('.shopify-section');
    if (announcementSection) {
      // Move the entire Shopify section wrapper before header-wrapper-container
      headerWrapper.parentNode.insertBefore(announcementSection, headerWrapper);
    }
  }

  hoistAnnouncementBar();

  // The theme editor re-renders header group sections back inside
  // header-wrapper-container, which drops the announcement bar under the sticky
  // nav again. Wire the re-hoist once — the editor can re-execute this file when
  // it re-renders the header, and we do not want the listeners to stack.
  if (!window.FDHeaderHoistBound) {
    window.FDHeaderHoistBound = true;
    document.addEventListener('shopify:section:load', hoistAnnouncementBar);
    document.addEventListener('shopify:section:reorder', hoistAnnouncementBar);
  }
})();

/**
 * Header Scroll Behavior Manager
 *
 * Handles scroll-based visibility for announcement bar and navigation:
 * - Desktop: Announcement bar only shows at scrollY === 0, nav bar always visible
 * - Mobile: Nav bar shows on scroll up, announcement bar only at scrollY === 0
 */
class HeaderScrollManager extends HTMLElement {
  connectedCallback() {


    this.lastScrollY = 0;
    this.ticking = false;
    this.announcementBar = document.querySelector('.shopify-section-announcement-bar');
    this.navBar = document.querySelector('.header-wrapper-container-nav-bar');
    this.mobileNavbar = document.querySelector('.mobile-navbar');

    window.addEventListener('scroll', () => this.onScroll(), { passive: true });
    window.addEventListener('resize', () => this.updateScrollState(), { passive: true });

    // Initial state
    this.updateScrollState();
  }

  onScroll() {



      if (!this.ticking) {
      requestAnimationFrame(() => {
        this.updateScrollState();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  updateScrollState() {
    const scrollY = window.scrollY;
    const isAtTop = scrollY <= 0;
    const isMobile = window.innerWidth < 990;
    const delta = scrollY - this.lastScrollY;
    // Deadband to swallow iOS momentum-scroll jitter — sub-pixel direction
    // flips during rubber-banding and finger-lift inertia were toggling the
    // navbar (and the subnav below it) multiple times per upward gesture.
    const SCROLL_THRESHOLD = 8;

    // Mobile nav: Show on scroll up or at top, hide on sustained scroll down.
    if (isMobile && this.mobileNavbar) {
      if (isAtTop) {
        this.mobileNavbar.classList.remove('header-scroll--hidden');
        this.lastScrollY = scrollY;
      } else if (delta > SCROLL_THRESHOLD && scrollY > 100) {
        this.mobileNavbar.classList.add('header-scroll--hidden');
        this.lastScrollY = scrollY;
      } else if (delta < -SCROLL_THRESHOLD) {
        this.mobileNavbar.classList.remove('header-scroll--hidden');
        this.lastScrollY = scrollY;
      }
      // Inside the deadband: hold lastScrollY so jitter accumulates instead
      // of flipping state every frame.
    } else {
      this.lastScrollY = scrollY;
    }

    // Desktop nav: Always visible (no class changes needed)
  }
}

// Guarded: the theme editor can re-execute this file on a header re-render, and a
// second define() throws, which would kill everything after it in this file.
if (!customElements.get('header-scroll-manager')) {
  customElements.define('header-scroll-manager', HeaderScrollManager);
}
